import React from 'react';
import './Registration27.css';
import Navbar from '../../components/navbar';
import PageHeader from '../../about/PageHeader';
import Footer from '../../components/Footer';

const Registration27 = () => {
  return (
     <>
      <Navbar />


      <PageHeader
        title="Registration"
        crumbs={[
          { label: "Home", href: "/" },
          { label: "Registration" },
        ]}
      />
    <div className="icaim-page-container">

   

      <div className="icaim-content-wrapper">
        {/* Main Registration Card */}
        <div className="icaim-registration-card">
          
          {/* Section 1: Registration Fees */}
          <div className="icaim-section-header">
            <div className="icaim-icon-box">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="icaim-svg-icon">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <h2>Registration Fees For Conference</h2>
          </div>

          <div className="icaim-table-responsive">
            <table className="icaim-table">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>
                    <div className="icaim-th-content">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="icaim-th-icon">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
                      </svg>
                      Delegates from India (In INR)
                    </div>
                  </th>
                  <th>
                    <div className="icaim-th-content">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="icaim-th-icon">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" />
                      </svg>
                      International Delegates (In USD)
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Industry and R&D organization</td>
                  <td>Rs. 2000</td>
                  <td>$ 50</td>
                </tr>
                <tr>
                  <td>Academia/Institution</td>
                  <td>Rs. 1500</td>
                  <td>$ 40</td>
                </tr>
                <tr>
                  <td>Student</td>
                  <td>Rs. 750</td>
                  <td>$ 20</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Info Note Box */}
          <div className="icaim-info-box">
            <div className="icaim-info-icon-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="icaim-info-svg">
                <path strokeLinecap="round" strokeLinejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
              </svg>
            </div>
            <p><strong>Note :</strong> Registration of at least one author is mandatory for the publication of paper in a conference proceedings. If two or more authors of the same paper want to attend the conference and require certificate of Participation, each of them must register and pay his/her respective registration fee.</p>
          </div>

          {/* Section 2: Payment Options */}
          <div className="icaim-section-header" style={{ marginTop: '40px' }}>
            <div className="icaim-icon-box">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="icaim-svg-icon">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
              </svg>
            </div>
            <h2>Payment Options for Registration</h2>
          </div>

          <ul className="icaim-bullet-list">
            <li>Registration fee can be paid by Cheque or Demand Draft drawn in favor of "Thakur Institute of Management Studies, Career Development & Research (T & C)"</li>
            <li>You can also make payment of Registration fees through online on the below account:</li>
          </ul>

          {/* Bank Details Box */}
          <div className="icaim-bank-box">
            <div className="icaim-bank-icon-area">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icaim-bank-svg">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.315 48.315 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z" />
              </svg>
            </div>
            <div className="icaim-bank-details-area">
              <div className="icaim-bank-row">
                <span className="icaim-bank-label">Beneficiary Name:</span>
                <span className="icaim-bank-value">Thakur Institute of Management Studies, Career Development & Research (T & C)</span>
              </div>
              <div className="icaim-bank-row">
                <span className="icaim-bank-label">Bank Name:</span>
                <span className="icaim-bank-value">Indian Bank, Kandivali (East), Mumbai</span>
              </div>
              <div className="icaim-bank-row">
                <span className="icaim-bank-label">Account No:</span>
                <span className="icaim-bank-value">04482021102</span>
              </div>
              <div className="icaim-bank-row">
                <span className="icaim-bank-label">IFSC Code:</span>
                <span className="icaim-bank-value">IDIB000K146</span>
              </div>
              <div className="icaim-bank-row">
                <span className="icaim-bank-label">Account Type:</span>
                <span className="icaim-bank-value">Savings</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
          <Footer />
    </>
  );
};

export default Registration27;